import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { AzureConnector } from '../../connector';

export const SqlService = IntegrationService.make({
  connector: AzureConnector,
  name: Integration_Service_Names_Enum.Sql,
});
